import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Carousel from "react-bootstrap/Carousel";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router";
import { Image, Collapse } from "react-bootstrap";
//import HamburgurIconMenu from "./HamburgurIconMenu";
//import { IconButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import AddDinerPopup from "../../reusableComponents/allPopupReusable/addDinerAndAddReservation/AddDinerPopup";
// import OfferPopup from "../../reusableComponents/allPopupReusable/offerEventPopup/OfferPopup";
// import EventPopup from "../../reusableComponents/allPopupReusable/offerEventPopup/EventPopup";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import { clear_all_errors } from "../../../store/actions/errorActions";
// import { logOutUser } from "../../../store/actions/authAction";
// import AddVendorSuggestionIssuesPopup from "../vendorOpenIssuesSuggestions/AddIssuesPopup/AddVendorSuggestionIssuesPopup";
// import AddUserTicketIssuesPopup from "../openIssuesVendor/AddUserTicketIssues/AddUserTicketIssuesPopup";
import {
  ReusableMenuLink,
  ReusableMenuLinkCollapse,
} from "../../vendorDashboardComponents/navigationSection/ReusableMenuLink";
import isEmpty from "../../../store/validation/is-Empty";
import SVG from "react-inlinesvg";
import Scrollbars from "react-custom-scrollbars";

import {
  create_and_update_restaurant,
  logOutUser,
} from "../../../store/actions/authAction";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

function HamburgerMenuReusable(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    hasSetMapProps: false,
    openNavbar: false,
    openRestaurantDetailsMenu: false,
    openHealthAndSanitization: false,
    openFoodCategories: false,
    openBankDetails: false,
    openSubscriptions: false,

    // Subscitption states
    openCasualFineDining: false,
    openFastFoodAndOther: false,
    openHospitalityAndHotels: false,
    openMultiBusinessServices: false,

    openOfferDetails: false,
    openOtherSettings: false,
    allData: {},
  });

  const data = useSelector((state) => {
    return !isEmpty(state.onboarding) ? state.onboarding.restaurantDetails : "";
  });
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const onSuccess = (e) => {
    // if (history.location.pathname === "/healthsenitation") {
    // window.location.reload();
    history.push("/healthsenitation");
    //   console.log("if", history);
    // } else {
    //   history.push("/healthsenitation", { selectedPage: e });
    //   console.log("else");
    // }
  };
  const onHamburgurClick = (e) => {
    document.getElementById("mySidenav").style.right = "0"; //329px
  };

  const closeNav = (e) => {
    document.getElementById("mySidenav").style.right = "-340px";
  };

  const subscriptionData = useSelector((state) => {
    return state.onboarding.onboard_subscription_details;
  });

  const subscriptionLocal = useSelector((state) => {
    return state.onboarding.subscriptionType;
  });

  const onLogoutClick = (e) => {
    e.preventDefault();
    dispatch(logOutUser());
  };

  const openRestaurantDetailsMenu = (e) => {
    setState({
      ...state,
      openRestaurantDetailsMenu: !state.openRestaurantDetailsMenu,
    });
  };
  const openHealthAndSanitization = (e) => {
    setState({
      ...state,
      openHealthAndSanitization: !state.openHealthAndSanitization,
    });
  };
  const openFoodCategories = (e) => {
    setState({
      ...state,
      openFoodCategories: !state.openFoodCategories,
    });
  };
  const openBankDetails = (e) => {
    setState({
      ...state,
      openBankDetails: !state.openBankDetails,
    });
  };

  // Subscription state management
  const openSubscriptions = (e) => {
    setState({
      ...state,
      openSubscriptions: !state.openSubscriptions,
    });
  };

  const openCasualFineDining = (e) => {
    setState({
      openSubscriptions: state.openSubscriptions,

      ...state,
      openCasualFineDining: !state.openCasualFineDining,
    });
  };

  const openFastFoodAndOther = (e) => {
    setState({
      openSubscriptions: state.openSubscriptions,

      ...state,
      openFastFoodAndOther: !state.openFastFoodAndOther,
    });
  };

  const openHospitalityAndHotels = (e) => {
    setState({
      openSubscriptions: state.openSubscriptions,

      ...state,
      openHospitalityAndHotels: !state.openHospitalityAndHotels,
    });
  };

  const openMultiBusinessServices = (e) => {
    setState({
      openSubscriptions: state.openSubscriptions,
      ...state,
      openMultiBusinessServices: !state.openMultiBusinessServices,
    });
  };

  const openOfferDetailsAction = (e) => {
    setState({
      ...state,
      openOfferDetails: !state.openOfferDetails,
    });
  };
  const openOtherSettings = (e) => {
    setState({
      ...state,
      openOtherSettings: !state.openOtherSettings,
    });
  };

  const entryPointHandler = (e) => {
    const formData = {
      selectedPage: 1,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess(1)));
  };

  const insideFacilityHandler = (e) => {
    const formData = {
      selectedPage: 2,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess(2)));
  };
  const employeesHandler = (e) => {
    const formData = {
      selectedPage: 3,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess(3)));
  };
  const foodPreparationHandler = (e) => {
    const formData = {
      selectedPage: 4,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess(4)));
  };
  const safetyHandler = (e) => {
    const formData = {
      selectedPage: 5,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess(5)));
  };
  const protocolHandler = (e) => {
    const formData = {
      selectedPage: 6,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess(6)));
  };

  return (
    <div>
      <div className="login-top-right-nav margin-hamburgur">
        <i
          className="fa fa-bars"
          aria-hidden="true"
          onClick={onHamburgurClick}
        ></i>
        <div id="mySidenav" className="sidenav">
          <div className="profile-and-close-css">
            <div className="w-100 d-flex align-items-center">
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Image
                    src={data.logo_url}
                    className="img-fluid profile-image-menu p-1"
                    alt="User"
                    title="User"
                  />
                </SRLWrapper>
              </SimpleReactLightbox>
              <div>
                <p>{data.restaurant_name}</p>
              </div>
              <SVG
                src={require("../../../assets/images/UserManagement/close.svg")}
                alt="Close"
                className="cursor hamburgur-class"
                onClick={closeNav}
              />
            </div>
          </div>

          {/* <i
                  className="fa fa-times hamburgur-class"
                  aria-hidden="true"
                  onClick={this.closeNav}
                ></i> */}
          <hr />
          <Scrollbars style={{ width: "100%", height: "calc(100vh - 126px)" }}>
            <ReusableMenuLink
              onClick={(e) => history.push("/mapsetup")}
              srcImage={require("../../../assets/images/RightNavigationIcon/map.svg")}
              headingText="Map Setup"
              styleClass={
                history.location.pathname === "/mapsetup" ||
                history.location.pathname === "/map-setup-two"
                  ? "border border-dark"
                  : ""
              }
            />
            <ReusableMenuLinkCollapse
              onClick={openRestaurantDetailsMenu}
              state={state.openRestaurantDetailsMenu}
              srcImage={require("../../../assets/images/RightNavigationIcon/restaurant.svg")}
              headingText="Business Details"
              styleClass={"border border-dark"}
            />
            <Collapse in={state.openRestaurantDetailsMenu}>
              <div id="example-collapse-text">
                <div className="example-collapse-text-inside">
                  <NavLink
                    exact
                    to="/restaurantsettings"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/refresh.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Update Business Details</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/pointofcontacts"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/telephone.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Point Of Contact</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/restaurantinfo"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/refresh.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Update Business Logo & Images</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/restaurantchains"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/link.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Business Settings</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/restauranttype"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/tray.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Business Type</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/paymenttype"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/pay.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Payment Methods</h4>
                  </NavLink>
                  <NavLink exact to="/parking" className="empty-div-selected">
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/parking.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Parking</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/petsallowed"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/dog.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Pets Allowed</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/dresscodetype"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/bow.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Dress Code</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/accessibility"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/wheelchair.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Accessibility</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/othresfeatures"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/settings.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Other features</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/serviceoffered"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/pay1.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Service offered</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/locatedinside"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/location.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Located Inside</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/pointofsale"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/location.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Point Of Sale System</h4>
                  </NavLink>
                </div>
              </div>
            </Collapse>
            <ReusableMenuLinkCollapse
              onClick={openHealthAndSanitization}
              state={state.openHealthAndSanitization}
              srcImage={require("../../../assets/images/RightNavigationIcon/hand-sanitizer.svg")}
              headingText="Health & Sanitization"
              styleClass={"border border-dark"}
            />
            <Collapse in={state.openHealthAndSanitization}>
              <div id="example-collapse-text">
                <div className="example-collapse-text-inside">
                  <div
                    onClick={entryPointHandler}
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/doorway.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Entrance</h4>
                  </div>
                  <div
                    onClick={insideFacilityHandler}
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/inside.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Inside Restaurant</h4>
                  </div>
                  <div
                    onClick={employeesHandler}
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/team.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Employees</h4>
                  </div>
                  <div
                    onClick={foodPreparationHandler}
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/Page.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Food Preparation</h4>
                  </div>
                  <div onClick={safetyHandler} className="empty-div-selected">
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/verified.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Food Safety</h4>
                  </div>
                  <div onClick={protocolHandler} className="empty-div-selected">
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/description.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Description Protocol</h4>
                  </div>
                </div>
              </div>
            </Collapse>
            <ReusableMenuLinkCollapse
              onClick={openFoodCategories}
              state={state.openFoodCategories}
              srcImage={require("../../../assets/images/RightNavigationIcon/chef-hat.svg")}
              headingText="Cuisine Setup"
              styleClass={"border border-dark"}
            />
            <Collapse in={state.openFoodCategories}>
              <div id="example-collapse-text">
                <div className="example-collapse-text-inside">
                  <NavLink
                    exact
                    to="/cuisinesetup"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/Page-1.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Food Category & Liquor Information</h4>
                  </NavLink>
                  <NavLink exact to="/foodtype" className="empty-div-selected">
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/spoon-and-fork.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Food Type</h4>
                  </NavLink>
                  <NavLink
                    exact
                    to="/multicuisine"
                    className="empty-div-selected"
                  >
                    <SVG
                      src={require("../../../assets/images/RightNavigationIcon/cocktail.svg")}
                      alt="Dashboard Icon"
                    />
                    <h4>Cuisine Offered</h4>
                  </NavLink>
                </div>
              </div>
            </Collapse>
            <ReusableMenuLink
              onClick={(e) => history.push("/businessHours")}
              srcImage={require("../../../assets/images/RightNavigationIcon/clock.svg")}
              headingText="Business Timings"
              styleClass={
                history.location.pathname === "/businessHours"
                  ? "border border-dark"
                  : ""
              }
            />
            <ReusableMenuLink
              onClick={(e) => history.push("/bankdetailshome")}
              srcImage={require("../../../assets/images/RightNavigationIcon/clock.svg")}
              headingText="KYC and License Info"
              styleClass={
                history.location.pathname === "/bankdetailshome"
                  ? "border border-dark"
                  : ""
              }
            />
            <ReusableMenuLinkCollapse
              onClick={openSubscriptions}
              state={state.openSubscriptions}
              srcImage={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
              headingText="Subscription"
            />

            <Collapse in={state.openSubscriptions}>
              <div id="example-collapse-text">
                <div className="example-collapse-text-inside">
                  <ReusableMenuLinkCollapse
                    onClick={openCasualFineDining}
                    state={state.openCasualFineDining}
                    srcImage={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                    headingText="Casual / Fine Dining"
                  />
                  <CasualFineDiningCollapse
                    state={state}
                    subscriptionLocal={subscriptionLocal}
                  />
                  <ReusableMenuLinkCollapse
                    onClick={openFastFoodAndOther}
                    state={state.openFastFoodAndOther}
                    srcImage={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                    headingText="Fast Food & Other"
                  />
                  <FastFoodCollapse
                    state={state}
                    subscriptionLocal={subscriptionLocal}
                  />
                  <ReusableMenuLinkCollapse
                    onClick={openHospitalityAndHotels}
                    state={state.openHospitalityAndHotels}
                    srcImage={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                    headingText="Hospitality & Hotels"
                  />
                  <HospitalityAndHotelsCollapse
                    state={state}
                    subscriptionLocal={subscriptionLocal}
                  />
                  <ReusableMenuLinkCollapse
                    onClick={openMultiBusinessServices}
                    state={state.openMultiBusinessServices}
                    srcImage={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                    headingText="Multi Service Business"
                  />
                  <MultiBusinessServiceCollapse
                    state={state}
                    subscriptionLocal={subscriptionLocal}
                  />
                </div>
              </div>
            </Collapse>
            {/* <ReusableMenuLinkCollapse
                    onClick={openSubscriptions}
                    state={state.openSubscriptions}
                    srcImage={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                    headingText="Subscription"
                  />
                  <Collapse in={state.openSubscriptions}>
                    <div id="example-collapse-text">
                      <div className="example-collapse-text-inside">
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Listing Service</h4>
                        </NavLink>
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Offers Management</h4>
                        </NavLink>
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Scan & Pay</h4>
                        </NavLink>
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Events Management</h4>
                        </NavLink>
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Live Streaming</h4>
                        </NavLink>
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Seating</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/"
                          className="empty-div-selected sub"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>General Seating</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/"
                          className="empty-div-selected sub"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Walk-In/Wait List</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/"
                          className="empty-div-selected sub"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Reservations</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/"
                          className="empty-div-selected sub"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Table Management</h4>
                        </NavLink>
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Ordering</h4>
                        </NavLink>
                        <NavLink exact to="/" className="empty-div-selected">
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Menu setup</h4>
                        </NavLink>
                      </div>
                    </div>
                  </Collapse> */}

            {/* <ReusableMenuLinkCollapse
                    onClick={openBankDetails}
                    state={state.openBankDetails}
                    srcImage={require("../../../assets/images/RightNavigationIcon/pay1.svg")}
                    headingText="Bank Details"
                  />
                  <Collapse in={state.openBankDetails}>
                    <div id="example-collapse-text">
                      <div className="example-collapse-text-inside">
                        <NavLink
                          exact
                          to="/bankdetailshome"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/money.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>KYC & Bank details</h4>
                        </NavLink>
                        <NavLink
                          exact
                          to="/seatingdashboard"
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/award.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>License</h4>
                        </NavLink>
                      </div>
                    </div>
                  </Collapse> */}

            {/* <ReusableMenuLink
              onClick={(e) => console.log("Other Settings")}
              srcImage={require("../../../assets/images/RightNavigationIcon/settings.svg")}
              headingText="Other Settings"
            /> */}

            <ReusableMenuLink
              onClick={onLogoutClick}
              srcImage={require("../../../assets/images/RightNavigationIcon/logout.svg")}
              headingText="Logout"
            />
          </Scrollbars>
        </div>
      </div>
    </div>
  );
}

export default HamburgerMenuReusable;

const CasualFineDiningCollapse = (props) => {
  const state = props.state;
  const subscriptionLocal = props.subscriptionLocal;

  return (
    <React.Fragment>
      <Collapse in={state.openCasualFineDining}>
        <div id="example-collapse-text">
          <div className="example-collapse-text-inside">
            <NavLink exact to="/subscription" className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Listing Service</h4>
            </NavLink>
            <NavLink exact to={"/subscription"} className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                alt="Dashboard Icon"
              />
              <h4>Offers Management</h4>
            </NavLink>

            <NavLink
              exact
              to={"/casual-fine-dining/scanandpay"}
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                alt="Dashboard Icon"
              />
              <h4>Scan & Pay</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/events"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Events Management</h4>
              </NavLink>
            ) : null}

            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/experience-management"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Experience Icon"
                />
                <h4>Experience Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={"/casual-fine-dining/livestreaming"}
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                alt="Dashboard Icon"
              />
              <h4>Live Streaming</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/generalseating"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>General Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Walk-In/Wait List</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/reservation"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Reservations</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/table"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Table Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={"/casual-fine-dining/ordering"}
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                alt="Dashboard Icon"
              />
              <h4>Ordering</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement"
                              className="empty-div-selected"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Seating</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/generalseating"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>General Seating</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Walk-In/Wait List</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/reservation"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Reservations</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/table"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Table Management</h4>
                            </NavLink>
                          ) : null} */}
            {/* <NavLink
                            exact
                            to={
                              subscriptionLocal && subscriptionLocal.casualDiningManagement
                                ? "/casual-fine-dining/menusetup"
                                : "/fastfood/menusetup"
                            }
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Ordering</h4>
                          </NavLink> */}
            <NavLink
              exact
              to={"/casual-fine-dining/menusetup"}
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                alt="Dashboard Icon"
              />
              <h4>Menu setup</h4>
            </NavLink>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};

const FastFoodCollapse = (props) => {
  const state = props.state;
  const subscriptionLocal = props.subscriptionLocal;

  return (
    <React.Fragment>
      <Collapse in={state.openFastFoodAndOther}>
        <div id="example-collapse-text">
          <div className="example-collapse-text-inside">
            <NavLink exact to="/subscription" className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Listing Service</h4>
            </NavLink>
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/offers"
                  : "/fastfood/offers"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                alt="Dashboard Icon"
              />
              <h4>Offers Management</h4>
            </NavLink>

            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/scanandpay"
                  : "/fastfood/scanandpay"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                alt="Dashboard Icon"
              />
              <h4>Scan & Pay</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/events"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Events Management</h4>
              </NavLink>
            ) : null}

            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/experience-management"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Experience Icon"
                />
                <h4>Experience Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/livestreaming"
                  : "/fastfood/livestreaming"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                alt="Dashboard Icon"
              />
              <h4>Live Streaming</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Seating</h4>
              </NavLink>
            ) : null} */}
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/generalseating"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>General Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Walk-In/Wait List</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/reservation"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Reservations</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/table"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Table Management</h4>
              </NavLink>
            ) : null} */}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/ordering"
                  : "/fastfood/ordering"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                alt="Dashboard Icon"
              />
              <h4>Ordering</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement"
                              className="empty-div-selected"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Seating</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/generalseating"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>General Seating</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Walk-In/Wait List</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/reservation"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Reservations</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/table"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Table Management</h4>
                            </NavLink>
                          ) : null} */}
            {/* <NavLink
                            exact
                            to={
                              subscriptionLocal && subscriptionLocal.casualDiningManagement
                                ? "/casual-fine-dining/menusetup"
                                : "/fastfood/menusetup"
                            }
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Ordering</h4>
                          </NavLink> */}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/menusetup"
                  : "/fastfood/menusetup"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                alt="Dashboard Icon"
              />
              <h4>Menu setup</h4>
            </NavLink>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};

const HospitalityAndHotelsCollapse = (props) => {
  const state = props.state;
  const subscriptionLocal = props.subscriptionLocal;

  return (
    <React.Fragment>
      <Collapse in={state.openHospitalityAndHotels}>
        <div id="example-collapse-text">
          <div className="example-collapse-text-inside">
            <NavLink exact to="/subscription" className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Listing Service</h4>
            </NavLink>
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/offers"
                  : "/fastfood/offers"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                alt="Dashboard Icon"
              />
              <h4>Offers Management</h4>
            </NavLink>

            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/scanandpay"
                  : "/fastfood/scanandpay"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                alt="Dashboard Icon"
              />
              <h4>Scan & Pay</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/events"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Events Icon"
                />
                <h4>Events Management</h4>
              </NavLink>
            ) : null}

            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/experience-management"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Experience Icon"
                />
                <h4>Experience Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/livestreaming"
                  : "/fastfood/livestreaming"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                alt="Dashboard Icon"
              />
              <h4>Live Streaming</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/generalseating"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>General Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Walk-In/Wait List</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/reservation"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Reservations</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/table"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Table Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/ordering"
                  : "/fastfood/ordering"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                alt="Dashboard Icon"
              />
              <h4>Ordering</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement"
                              className="empty-div-selected"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Seating</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/generalseating"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>General Seating</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Walk-In/Wait List</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/reservation"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Reservations</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/table"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Table Management</h4>
                            </NavLink>
                          ) : null} */}
            {/* <NavLink
                            exact
                            to={
                              subscriptionLocal && subscriptionLocal.casualDiningManagement
                                ? "/casual-fine-dining/menusetup"
                                : "/fastfood/menusetup"
                            }
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Ordering</h4>
                          </NavLink> */}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/menusetup"
                  : "/fastfood/menusetup"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                alt="Dashboard Icon"
              />
              <h4>Menu setup</h4>
            </NavLink>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};

const MultiBusinessServiceCollapse = (props) => {
  const state = props.state;
  const subscriptionLocal = props.subscriptionLocal;

  return (
    <React.Fragment>
      <Collapse in={state.openMultiBusinessServices}>
        <div id="example-collapse-text">
          <div className="example-collapse-text-inside">
            <NavLink exact to="/subscription" className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Listing Service</h4>
            </NavLink>
            <NavLink
              exact
              to={"multi-service/offers"}
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                alt="Dashboard Icon"
              />
              <h4>Offers Management</h4>
            </NavLink>

            <NavLink
              exact
              to={"multi-service/scanandpay"}
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                alt="Dashboard Icon"
              />
              <h4>Scan & Pay</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? ( */}
            <NavLink
              exact
              to="/multi-service/events"
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                alt="Dashboard Icon"
              />
              <h4>Events Management</h4>
            </NavLink>

            <NavLink
              exact
              to="/multi-service/experience-management"
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                alt="Experience Icon"
              />
              <h4>Experience Management</h4>
            </NavLink>
            {/* ) : null} */}
            <NavLink
              exact
              to={
                // subscriptionLocal && subscriptionLocal.casualDiningManagement
                //   ? "/casual-fine-dining/livestreaming"
                //   :
                "/multi-service/livestreaming"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                alt="Dashboard Icon"
              />
              <h4>Live Streaming</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? ( */}
            <NavLink
              exact
              to="/multi-service/seatingmanagement"
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Seating</h4>
            </NavLink>
            {/* ) : null} */}
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? ( */}
            <NavLink
              exact
              to="/multi-service/seatingmanagement/generalseating"
              className="empty-div-selected sub"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>General Seating</h4>
            </NavLink>
            {/* ) : null} */}
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? ( */}
            <NavLink
              exact
              to="/multi-service/seatingmanagement/walkinwaitlist"
              className="empty-div-selected sub"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                alt="Dashboard Icon"
              />
              <h4>Walk-In/Wait List</h4>
            </NavLink>
            {/* ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? ( */}
            <NavLink
              exact
              to="/multi-service/seatingmanagement/reservation"
              className="empty-div-selected sub"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                alt="Dashboard Icon"
              />
              <h4>Reservations</h4>
            </NavLink>
            {/* ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? ( */}
            <NavLink
              exact
              to="/multi-service/seatingmanagement/table"
              className="empty-div-selected sub"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                alt="Dashboard Icon"
              />
              <h4>Table Management</h4>
            </NavLink>
            {/* ) : null} */}
            <NavLink
              exact
              to={
                // subscriptionLocal && subscriptionLocal.casualDiningManagement
                //   ? "/casual-fine-dining/ordering"
                //   :
                "/multi-service/ordering"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                alt="Dashboard Icon"
              />
              <h4>Ordering</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement"
                              className="empty-div-selected"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Seating</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/generalseating"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>General Seating</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Walk-In/Wait List</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/reservation"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Reservations</h4>
                            </NavLink>
                          ) : null}
                          {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                            <NavLink
                              exact
                              to="/casual-fine-dining/seatingmanagement/table"
                              className="empty-div-selected sub"
                            >
                              <SVG
                                src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                                alt="Dashboard Icon"
                              />
                              <h4>Table Management</h4>
                            </NavLink>
                          ) : null} */}
            {/* <NavLink
                            exact
                            to={
                              subscriptionLocal && subscriptionLocal.casualDiningManagement
                                ? "/casual-fine-dining/menusetup"
                                : "/fastfood/menusetup"
                            }
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Ordering</h4>
                          </NavLink> */}
            <NavLink
              exact
              to={
                // subscriptionLocal && subscriptionLocal.casualDiningManagement
                //   ? "/casual-fine-dining/menusetup"
                //   :
                "/multi-service/menusetup"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                alt="Dashboard Icon"
              />
              <h4>Menu setup</h4>
            </NavLink>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};
